import avatar from "./avatar.svg";
import dart from "./dart.png";
import dashboard from "./dashboard.png";
import flag from "./flag.png";
import hrxLogoLight from "./hrx-logo-light.png";
import hrxLogo from "./hrxLogo.svg";
import hrx from "./hrx.svg";
import note from "./note.png";
import optimize from "./optimize.png";
import paymentDesktop from "./payment-dasktop.png";
import paymentMobile from "./payment-mobile.png";
import paymentTab from "./payment-tab.png";
import placeholder from "./placeholder.svg";
import signature from "./signature.svg";
import ssl from "./ssl.svg";
import xLogo from "./x-logo.png";

const IMAGES = {
  ssl,
  hrx,
  dart,
  flag,
  note,
  xLogo,
  avatar,
  hrxLogo,
  optimize,
  dashboard,
  signature,
  placeholder,
  hrxLogoLight,
  paymentTab,
  paymentDesktop,
  paymentMobile,
};

export default IMAGES;
